import { render, staticRenderFns } from "./ProfileHeaderBackground.vue?vue&type=template&id=d317198a&scoped=true&functional=true&"
import script from "./ProfileHeaderBackground.vue?vue&type=script&lang=ts&"
export * from "./ProfileHeaderBackground.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileHeaderBackground.vue?vue&type=style&index=0&id=d317198a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "d317198a",
  null
  
)

export default component.exports